import { React, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import PropTypes from 'prop-types'

import './header.css'

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

const getCurrentViewHeroHeight = (pathname) => {
  switch (pathname) {
    case '/':
      return 0.92
    case '/gallery':
      return 0.4
    case '/faqs':
      return 0.65
    default:
      return 0
  }
}

const Header = (props) => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const height = getWindowDimensions().height * getCurrentViewHeroHeight(location.pathname);

      if (window.scrollY > height) {
        document.querySelector(".header-header")?.classList.add('fade-bg');
        document.querySelectorAll(".header-heading").forEach(el => el.classList.add('fade-colour'));
        document.querySelectorAll(".header-supporting-text").forEach(el => el.classList.add('fade-in'));
        document.querySelector(".header-burger-menu")?.classList.add('fade-fill');
        document.querySelectorAll(".header-icons").forEach(el => el.classList.add('fade-fill'));
      } else {
        document.querySelector(".header-header")?.classList.remove('fade-bg');
        document.querySelectorAll(".header-heading").forEach(el => el.classList.remove('fade-colour'));
        document.querySelectorAll(".header-supporting-text").forEach(el => el.classList.remove('fade-in'));
        document.querySelector(".header-burger-menu")?.classList.remove('fade-fill');
        document.querySelectorAll(".header-icons").forEach(el => el.classList.remove('fade-fill'));
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, [location]);

  return (
    <div data-role="Header" className={`header-header ${props.rootClassName} `}>

      <div className="header-container">
        <div className="header-container-links">
          <Link to="/" className="header-navlink">
            <h1 className="header-heading">{props.heading1}</h1>
          </Link>
          <Link to="/faqs" className="header-navlink">
            <h1 className="header-heading">{props.heading2}</h1>
          </Link>
          <Link to="/gallery" className="header-navlink">
            <h1 className="header-heading">{props.heading3}</h1>
          </Link>
        </div>
      </div>

      <div className="header-container header-container-middle">
        <div className="header-container-logo">
          <Link to="/" className="header-navlink">
            <div className="inner-navlink inner-navlink-first"><h1 className="header-text-1 header-supporting-text">TRIPLE C</h1></div>
            <div className="inner-navlink inner-navlink-center"><img className="header-logo" src="../../playground_assets/logo-transparent.png" alt="TRIPLE C"/></div>
            <div className="inner-navlink inner-navlink-last"><h1 className="header-text-2 header-supporting-text">THERAPY</h1></div>
          </Link>
        </div>
      </div>

      <div className="header-container">
        <div className="header-container-socials">
          <a className="header-url" href='https://api.whatsapp.com/send?phone=447956292298'>
<svg className="header-icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg>
          </a>
          <a className="header-url" href='https://www.instagram.com/triplectherapy/'>
<svg className="header-icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
          </a>
          <a className="header-url" href='mailto:bookings@triplectherapy.co.uk'>
<svg className="header-icons header-icon-email" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z"/></svg>
          </a>
        </div>
      </div>

      <div className="header-burger-menu" onClick={toggleMenu}>
        <svg viewBox="0 0 1024 1024" className="header-icon">
          <path
            d="M128 256h768v86h-768v-86zM128 554v-84h768v84h-768zM128 768v-86h768v86h-768z"
            className=""
          ></path>
        </svg>
      </div>
      
      <div className={`header-mobile-menu ${menuOpen ? 'mobile-menu-open' : ''}`}>
        <div className="header-top">
          <div className="header-close-menu" onClick={closeMenu}>
            <svg viewBox="0 0 1024 1024" className="header-icon10">
              <path
                d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"
                className=""
              ></path>
            </svg>
          </div>
        </div>
        <div className="header-mid">
          <Link to="/" className="header-navlink2" onClick={closeMenu}>
            <span className="header-text textLG">{props.heading1}</span>
          </Link>
          <Link to="/faqs" className="header-navlink2" onClick={closeMenu}>
            <span className="header-text textLG">{props.heading2}</span>
          </Link>
          <Link to="/gallery" className="header-navlink2" onClick={closeMenu}>
            <span className="header-text textLG">{props.heading3}</span>
          </Link>
        </div>
        <div className="header-bot">
          <a href='https://api.whatsapp.com/send?phone=447956292298' target="_blank" rel="noreferrer noopener">
            <svg className="header-mobile-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg>
          </a>
          <a href='https://www.instagram.com/triplectherapy/' target="_blank" rel="noreferrer noopener">
            <svg className="header-mobile-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
          </a>
          <a href='mailto:bookings@triplectherapy.co.uk'>
            <svg className="header-mobile-icon header-mobile-icon-email" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z"/></svg>
          </a>
        </div>
      </div>

    </div>
  )
}

Header.defaultProps = {
  route: '',
  rootClassName: '',
  heading11: 'Home',
  heading1: 'Home',
  heading2: 'FAQs',
  heading3: 'Gallery',
}

Header.propTypes = {
  route: PropTypes.string,
  rootClassName: PropTypes.string,
  heading11: PropTypes.string,
  heading1: PropTypes.string,
  heading2: PropTypes.string,
  heading3: PropTypes.string,
}

export default Header
